
import {PlatformUtils} from "./platform-utils";

export class PricingUtils{

  /**
   * Retrieves the research amount based on the user's pricing information stored in the session.
   * If the user's research price is not available, a default value is returned.
   *
   * @return {number} The research price for the user or the default value of 29.95.
   */
  public static getResearchAmount(): number {
    const pricing = PlatformUtils.getPlatformPricing();
    if (pricing?.researchPrice) {
      return pricing.researchPrice;
    }
    return 29.95;
  }

  /**
   * Retrieves the base price for bauak services for a given user.
   *
   * Looks up the value in `user.userPricing.additionalPositions['bauakBasePrice']`
   * if it exists. If no custom pricing is configured for the user, a default
   * base price of 150 is returned.
   *
   * @return Configured base price if available, otherwise the default (150)
   */
  public static getBauakBasePrice() : number {
    const pricing = PlatformUtils.getPlatformPricing();
    if(pricing?.additionalPositions && pricing.additionalPositions['bauakBasePrice'] !== undefined){
      return pricing.additionalPositions['bauakBasePrice']
    }
    else {
      return 150;
    }
  }

  /**
   * Retrieves the hourly price for bauak services for a given suer
   *
   * Looks up the value in `user.userPricing.additionalPositions['bauakPricePerHour']`
   * if it exists. If no custom pricing is configured for the user, a default
   * hourly price of 140 is returned.
   *
   * @returns Configured hourly price if available, otherwise the default (140).
   */
  public static getBauakPricePerHour(): number{
    const pricing = PlatformUtils.getPlatformPricing();
    if(pricing?.additionalPositions && pricing.additionalPositions['bauakPricePerHour'] !== undefined){
      return pricing.additionalPositions['bauakPricePerHour']
    }
    else {
      return 140;
    }
  }

  /**
   * Gets the fixed price for a user based on their pricing configuration.
   *
   * @return {number} The fixed price for the user. If a specific price is defined in the user's pricing configuration, that value is returned; otherwise, a default value of 150 is returned.
   */
  public static getFixedBewilPrice(): number {
    const pricing = PlatformUtils.getPlatformPricing();
    if (pricing?.additionalPositions && pricing.additionalPositions['fixedBewilPrice'] !== undefined ) {
      return pricing.additionalPositions['fixedBewilPrice'];
    } else {
      return 150;
    }
  }

  /**
   * Calculates and returns the price for a Bewil Certificate based on the user's pricing configuration.
   * Note: When the CertificatePrice is set to 0 (zero) then only the getBewilFixedPrice has to be considered
   *
   * @return {number} The calculated price for the Bewil Certificate. Defaults to 95 if no specific user price is set.
   */
  public static getBewilCertificatePrice(): number {
    const pricing = PlatformUtils.getPlatformPricing();
    if (pricing?.additionalPositions && pricing.additionalPositions['bewilCertificatePrice'] !== undefined ) {
      return pricing.additionalPositions['bewilCertificatePrice'];
    } else {
      return 95;
    }
  }


  /**
   * Retrieves the pricing for "manual_teilung" from the platform's additional positions.
   * If the "manual_teilung" value is not defined, it returns a default value of 180.
   *
   * @return {number} The pricing value for "manual_teilung" or the default value of 180.
   */
  public static getTeilunPricing() : number {
    const pricing = PlatformUtils.getPlatformPricing();
    if(pricing?.additionalPositions && pricing.additionalPositions['manual_teilung'] !== undefined){
      return pricing.additionalPositions['manual_teilung']
    }
    else {
      return 180;
    }
  }

}
